import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { isDeveloperRole } from "../utils/roles";

/**
 * Knowledge Base access: DEVELOPER or SUPER_ADMIN only.
 * ADMIN / owners are redirected to /admin with an unauthorized flag.
 */
export default function RequireDeveloper({ children }) {
  const { user, role, profile, claimsReady, profileReady, loading } = useAuth();
  const location = useLocation();

  if (loading || !claimsReady || (user && !profileReady)) {
    return <div className="page-loading">جاري التحقق من الصلاحيات...</div>;
  }

  if (!user) {
    return <Navigate to="/admin" replace state={{ from: location }} />;
  }

  if (role === "CHALET_OWNER") {
    return <Navigate to="/owner" replace />;
  }

  const claimOk = isDeveloperRole(role);
  const profileOk = isDeveloperRole(profile?.role);
  const disabled = profile?.status === "disabled";

  if (disabled || !claimOk || !profileOk) {
    return <Navigate to="/admin" replace />;
  }

  return children;
}
